// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__uHb+o","shine":"Loading_shine__loxje"};